import { AgendaItemCategory } from '@orgbrain/lib-data';
import {  AgendaItemVoting } from './lib-admin';
import { DecisionVoteOption } from './voting';

export enum VoteResultsOptions {
  FOR = 'FOR',
  AGAINST = 'AGAINST',
  NEUTRAL = 'NEUTRAL',
  DIGITAL = 'DIGITAL',
  FOR_IMPLICIT = 'FOR_IMPLICIT',
  NEUTRAL_IMPLICIT = 'NEUTRAL_IMPLICIT',
}

export interface VoteResultsMap {
  [userId: string]: VoteResultsOptions;
}

export interface DecisionVotesMap {
  [userId: string]: DecisionVoteOption;
}

export interface ElectionVotesCandidateIdsToVoterIdsMap {
  [candidateId: string]: string[];
}

export const VoteResultsOptionsMapReverse = {
  [VoteResultsOptions.FOR]: 'votingFor',
  [VoteResultsOptions.AGAINST]: 'votingAgainst',
  [VoteResultsOptions.NEUTRAL]: 'votingNeutral',
  [VoteResultsOptions.DIGITAL]: 'votingDigital',
};

export const VoteResultsOptionsMap = {
  votingFor: VoteResultsOptions.FOR,
  votingAgainst: VoteResultsOptions.AGAINST,
  votingNeutral: VoteResultsOptions.NEUTRAL,
};

export interface AgendaItemAttachment {
  id: string;
  direntId: string;
  name: string;
  iHaveSeenThisAttachment: string[];
}

export class AgendaItem {
  id: string;
  title: string;
  description: string;
  agendaItemCategory: AgendaItemCategory;
  duration?: number;
  agendaStartingIndex?: number;
  agendaResponsible?: string;
  agendaItemIsPrivate?: boolean;
  agendaItemOpenSpeakingList?: boolean;
  agendaItemIsDraft?: boolean;
  agendaItemHasCommentsEnabled?: boolean;
  hideAgendaNumbering?: boolean;
  proposedResolution?: string;
  voting?: AgendaItemVoting;
  agendaItemSuggestionBasis: any;
  iHaveSeenThisAgendaItem?: string[];
  agendaItemAttachedFiles: string[];
  agendaItemAttachments: AgendaItemAttachment[];
  minuteNotes: string;
  decisionNotes: string;
  drawResolutionVote?: boolean;
  pauseAwareIndex?: number;
  public static fromTitle(title: string): AgendaItem {
    const agendaItem = new AgendaItem();
    agendaItem.title = title;
    return agendaItem;
  }
}
